// What each kind of schedule assignment is called wherever it is labelled, so a folder rule is
// never mistaken for a schedule (the board's chips, the cost breakdown)
export const ASSIGNMENT_KIND_NAMES = { folder: "Folder", schedule: "Schedule", task: "Task" }
